var map = {
	"./Heco-logo.png": 245,
	"./Metis-logo.png": 246,
	"./arrow-down-blue.svg": 486,
	"./arrow-down-grey.svg": 487,
	"./arrow-right-white.png": 488,
	"./arrow-right.svg": 489,
	"./big_unicorn.png": 236,
	"./blue-loader.svg": 74,
	"./bnb.svg": 247,
	"./circle-grey.svg": 490,
	"./circle.svg": 491,
	"./coinbaseWalletIcon.svg": 146,
	"./dropdown-blue.svg": 492,
	"./dropdown.svg": 493,
	"./dropup-blue.svg": 494,
	"./ethereum-logo.png": 248,
	"./fortmaticIcon.png": 147,
	"./giveswap_logo.png": 242,
	"./giveswap_logo_dark.png": 243,
	"./link.svg": 495,
	"./magnifying-glass.svg": 496,
	"./menu.svg": 497,
	"./metamask.png": 244,
	"./moon-ethereum-logo.png": 498,
	"./noise.png": 238,
	"./o-goswap_logo.png": 499,
	"./o-goswap_logo_dark.png": 500,
	"./plus-blue.svg": 501,
	"./plus-grey.svg": 502,
	"./portisIcon.png": 148,
	"./question-mark.svg": 503,
	"./question.svg": 504,
	"./spinner.svg": 505,
	"./token-list/lists-dark.png": 506,
	"./token-list/lists-light.png": 507,
	"./token-logo.png": 115,
	"./trustWallet.png": 508,
	"./walletConnectIcon.svg": 149,
	"./x.svg": 509,
	"./xl_uni.png": 237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;